import { Circle, CheckSquare, Bug, Zap, GitBranch, Layers, FileText, ListTree, Flag, Star, Bookmark, Rocket, Wrench, Shield, Bell, Target, Package, Beaker, Palette, Code2, Component, Sparkles, ClipboardList, Cog, ChevronsUp, ChevronUp, Equal, ChevronDown, ChevronsDown } from 'lucide-vue-next'

/**
 * Curated lucide icon set selectable on a ticket type. The chosen icon is stored
 * on the type as the lucide component name and reused wherever a type is shown
 * (config, board, Gantt). Fallback = Circle.
 */
export const TYPE_ICON_MAP = {
    Circle, CheckSquare, Bug, Zap, GitBranch, Layers, FileText, ListTree, Flag, Star,
    Bookmark, Rocket, Wrench, Shield, Bell, Target, Package, Beaker, Palette, Code2,
    Component, Sparkles, ClipboardList, Cog,

    // Priorities carry their own five, and they are directional on purpose: a single
    // chevron for High, a double for Highest, and the bar for Medium. Rank reads faster
    // as a shape than as a word, which is the whole reason the column is worth an icon.
    ChevronsUp, ChevronUp, Equal, ChevronDown, ChevronsDown,
}
export const TYPE_ICON_NAMES = Object.keys(TYPE_ICON_MAP)

/**
 * Resolve a stored icon name to its component.
 *
 * Two naming conventions reach this, because two tables were seeded by different hands:
 * ticket_types store `CheckSquare`, ticket_priorities store `chevrons-up`. A lookup that
 * only knew the first returned the Circle fallback for EVERY priority — which is why the
 * priority filter drew five identical coloured dots and the table drew no icon at all.
 *
 * So kebab-case is normalised rather than the data being migrated: both spellings are
 * already in production, and a rename would have to be right in one pass across two
 * tables, the config screens that write them, and every row already stored.
 */
export function typeIconComponent(name) {
    if (! name) return Circle
    if (TYPE_ICON_MAP[name]) return TYPE_ICON_MAP[name]

    const pascal = String(name).replace(/(^|-)([a-z])/g, (_, __, c) => c.toUpperCase())

    return TYPE_ICON_MAP[pascal] || Circle
}
